// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleSecondModalClose } from '../../storage/actions/modalsActions';
import CustomSelect from '../layout/CustomSelect';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../utils/customSelectStyle';
import { SUSPENSION_REASON_OPTIONS, SUSPENSION_TIMEFRAME_OPTIONS } from '../../utils/constans';
import Notification from '../notification';

const SuspendContractorModal = ({ toggleSecondModalClose, modalState }) => {
  const type = modalState?.type || {};
  const contractorName = type.contractorName || 'this contractor';

  const [step, setStep] = useState('confirm');
  const [reason, setReason] = useState(null);
  const [timeframe, setTimeframe] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (modalState?.isOpen) {
      setStep('confirm');
      setReason(null);
      setTimeframe(null);
      setSubmitting(false);
    }
  }, [modalState?.isOpen]);

  const onClose = () => {
    if (submitting) return;
    toggleSecondModalClose('suspendContractorModal', true);
  };

  const onCancel = () => {
    if (typeof type.onCancel === 'function') type.onCancel();
    onClose();
  };

  const onSubmit = async () => {
    if (!reason) {
      Notification('warning', { message: 'Please select a suspension reason.' });
      return;
    }
    if (!timeframe) {
      Notification('warning', { message: 'Please select a suspension timeframe.' });
      return;
    }
    setSubmitting(true);
    try {
      await type.onConfirm?.({ reason: reason.value, timeframe: timeframe.value });
      toggleSecondModalClose('suspendContractorModal', true);
    } catch (error) {
      setSubmitting(false);
    }
  };

  if (!modalState?.isOpen) return null;

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title">
            {step === 'confirm' ? 'Suspend account' : 'Suspension details'}
          </div>
          <button type="button" className="close_btn" aria-label="close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal_body">
          {step === 'confirm' ? (
            <div className="modal_content">
              Please confirm that you want to fully suspend
              {' '}
              <strong>{contractorName}</strong>
              {'’s account. '}
              While suspended, the contractor can still log in and view work, but cannot
              apply to new work orders or accept routed work orders.
            </div>
          ) : (
            <>
              <div className="modal_content">
                Select the suspension reason and how long it should remain in effect.
                The contractor will be emailed the reason and duration.
              </div>

              <div className="field_col">
                <label className="field_name" htmlFor="suspend-reason">Suspension reason</label>
                <div className="dashboard-select-wrap">
                  <CustomSelect
                    inputId="suspend-reason"
                    styles={dashboardSelectStyle}
                    classNames={dashboardSelectClassNames}
                    options={SUSPENSION_REASON_OPTIONS}
                    value={reason}
                    onChange={setReason}
                    placeholder="Select a reason"
                    isSearchable={false}
                  />
                </div>
              </div>

              <div className="field_col">
                <label className="field_name" htmlFor="suspend-timeframe">Suspension timeframe</label>
                <div className="dashboard-select-wrap">
                  <CustomSelect
                    inputId="suspend-timeframe"
                    styles={dashboardSelectStyle}
                    classNames={dashboardSelectClassNames}
                    options={SUSPENSION_TIMEFRAME_OPTIONS}
                    value={timeframe}
                    onChange={setTimeframe}
                    placeholder="Select a timeframe"
                    isSearchable={false}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <div className="modal_footer modal_footer--suspend">
          {step === 'confirm' ? (
            <>
              <button
                type="button"
                className="dashboard-btn dashboard-btn--suspend-confirm"
                onClick={() => setStep('details')}
              >
                Suspend
              </button>
              <button
                type="button"
                className="dashboard-btn dashboard-btn--suspend-cancel"
                onClick={onCancel}
              >
                Cancel
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="dashboard-btn dashboard-btn--suspend-confirm"
                onClick={onSubmit}
                disabled={submitting}
              >
                {submitting ? 'Suspending…' : 'Suspend'}
              </button>
              <button
                type="button"
                className="dashboard-btn dashboard-btn--suspend-cancel"
                onClick={onCancel}
                disabled={submitting}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.suspendContractorModal,
});

export default connect(mapStateToProps, { toggleSecondModalClose })(SuspendContractorModal);
